export default {
  screens: [
    {
      type: 'intro',
      title: '쇼메',
      content:
        '쇼메는 방돔 광장에 최초로 입성한 주얼리 하우스입니다. 1812년, 현재 리츠 호텔이 들어선 곳에 처음으로 자리를 잡은 것을 시작으로 파리지앵 주얼러의 역사가 시작되었습니다.',
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        '쇼메는 1907년에 현재 메종이 위치한 방돔 광장 12번지로 이전했습니다. 이 저택에는 쇼메의 역사적인 스토어와 특별한 살롱, 제작 스튜디오 및 하이 주얼리 공방이 마련되어 있습니다.',
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '쇼메의 눈부신 성공을 증명해 주는 특별한 장소.<br><br> 언제나 새롭고 혁신적인 주얼리를 선보였던 쇼메의 창립자, 마리-에티엔느 니토(Marie-Etienne Nitot)는 자신만의 탁월한 주얼리 메이킹 노하우를 후대에 고스란히 전수했습니다.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/home.js